import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  INotification,
  NotificacionService,
} from 'src/app/services/notificaciones.service';
import { onScroll } from '../../../modules/dashboard/utils/on_scroll_down';

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.scss'],
})
export class NotificacionesComponent implements OnInit, AfterViewInit {
  focusComponent = true;

  @Input() notificaciones: INotification[] = [];
  @Input() view = false;
  @Output() hidden = new EventEmitter<boolean>();

  @HostListener('click')
  clickInside() {
    this.focusComponent = true;
  }

  @HostListener('document:click')
  clickout() {
    if (this.focusComponent && this.view) {
      this.focusComponent = false;
    } else {
      this.close();
      this.focusComponent = true;
    }
  }

  ngAfterViewInit(): void {
    let content = <HTMLDivElement>document.getElementById('Notificaciones');
    content.onscroll = this.detectScroll.bind(this);
  }

  constructor(private _notificaciones: NotificacionService) {
    this._notificaciones.updatedNotifications.subscribe((type) => {
      this.notificaciones = [];
      this.isAll = false;
      this.skip = 0;
      this.type = type;
      this.getNotifications();
    });
  }

  ngOnInit(): void {
    this.getNotifications();
  }

  isLoading = false;
  isAll = false;
  skip = 0;
  type = 'all';
  getNotifications() {
    this.isLoading = true;
    this._notificaciones.obtenerNotificaciones(this.type, this.skip).subscribe({
      next: (data) => {
        this.notificaciones = [...this.notificaciones, ...data];
        this.skip += 15;
        this.isLoading = false;
        if (data.length < 15) this.isAll = true;
      },
    });
  }

  close() {
    this.hidden.emit(true);
  }

  marcarLeidas() {
    this._notificaciones.allAsRead();
 
  }

  detectScroll(event) {
    let isDown = onScroll(event.target);
    if (!isDown || this.isLoading || this.isAll) return;
    this.getNotifications();
  }
}
